// extracted by mini-css-extract-plugin
export default {"container":"EmailNotificationsGroupInput_container__NX1td","switch":"EmailNotificationsGroupInput_switch__NDOax","rules":"EmailNotificationsGroupInput_rules__KUZhe"};